
$('body').on('click', '[data-open-exam-form]', function (e){
  e.preventDefault()
  $('.mfp-popup-link').magnificPopup('close')
})

$('body').on('click', '.exams-form .form-field.error', function (e){
  $(this).removeClass('error')
})
